import React, { ChangeEvent, KeyboardEvent, useEffect, useRef } from 'react';
import './query-message-input.scss';
import { TouchableOpacity } from '../../../common';
import { ReactComponent as AddPlusIcon } from '@zonofi/svg-icons/add-plus-icon-filled.svg';
import { ReactComponent as SendMessageIcon } from '@zonofi/svg-icons/send-message-filled.svg';
import { useMessageInput } from '../../../conversations';
import { CircularProgress } from '@mui/material';

interface QueryMessageInputProps {
  channelId: string;
  conversationId: string;
  handleSendMsg: () => void;
}

export const QueryMessageInput: React.FC<QueryMessageInputProps> = ({
  channelId,
  conversationId,
  handleSendMsg,
}) => {
  const {
    sendMessage,
    handleInputChange: onInputChange,
    text,
    loader,
    inputDisabled,
    onUploadMedia,
    file,
    setFile,
  } = useMessageInput({
    channelId,
    conversationId,
    handleSendMsg,
  });

  const inputRef = useRef<HTMLTextAreaElement>(null);
  const singleLineHeightRef = useRef<number>(0);

  const handleInputChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    try {
      const { value: newText } = event.target;
      onInputChange(newText);

      const textarea = event.target;
      textarea.style.height = 'inherit';
      textarea.style.overflow = 'hidden';

      const scrollHeight = textarea.scrollHeight;
      const singleLine = singleLineHeightRef.current;

      if (scrollHeight > singleLine) {
        textarea.style.height = `${Math.min(scrollHeight, 100)}px`;
        textarea.style.overflow = scrollHeight >= 100 ? 'auto' : 'hidden';
      } else {
        textarea.style.height = `${singleLine}px`;
        textarea.style.overflow = 'hidden';
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleKeyPress = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    try {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        sendMessage?.();
        inputRef.current?.setAttribute('rows', '1');
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.height = 'inherit';
      singleLineHeightRef.current = inputRef.current.scrollHeight;
      inputRef.current.style.height = `${singleLineHeightRef.current}px`;
    }
  }, []);

  return (
    <div className="query-message__input">
      <div className="query-message__container">
        {/* <TouchableOpacity onPress={() => {}}>
          <AddPlusIcon color="#32A7E8" />
        </TouchableOpacity> */}
        <div className="query-message__input-wrapper">
          <textarea
            placeholder="Type Message"
            ref={inputRef}
            rows={1}
            value={text}
            className={'query-message__text-area font-regular'}
            onChange={handleInputChange}
            onKeyDown={handleKeyPress}
          />
        </div>

        {loader ? (
          <CircularProgress size={20} color="primary" />
        ) : (
          <TouchableOpacity
            onPress={() => sendMessage?.()}
            disabled={inputDisabled}
          >
            <SendMessageIcon color="#32A7E8" />
          </TouchableOpacity>
        )}
      </div>
    </div>
  );
};
